module.exports = __webpack_public_path__ + "static/media/anage-imobiliaria-joinville.77ec22e6.webp";